export const formatWeekDay = (date: Date) => {
	let formatWeekDay = date.toLocaleDateString('pt-br', { weekday: 'short' })
	formatWeekDay = formatWeekDay.charAt(0).toUpperCase() + formatWeekDay.slice(1, -1) + ','
	return formatWeekDay
}
